import { useMemo } from 'react';

import { useDictionaryByType } from 'hooks/use-dictionary-by-type';
import type { DictionaryByTypeName } from 'hooks/use-dictionary-by-type';

interface UseDictionaryOptionsParams {
  userId: string;
  type: DictionaryByTypeName;
  enabled?: boolean;
  exclude?: ReadonlySet<string>;
}

export interface UseDictionaryOptionsResult {
  options: { value: string; label: string }[];
  isLoading: boolean;
}

export const useDictionaryOptions = ({
  userId,
  type,
  enabled,
  exclude,
}: UseDictionaryOptionsParams): UseDictionaryOptionsResult => {
  const query = useDictionaryByType(userId, type, { enabled });

  const options = useMemo(
    () =>
      (query.data ?? [])
        .map((item) => ({
          value: item.name ?? '',
          label: item.description ?? item.name ?? '',
        }))
        .filter((option) => !!option.value && !exclude?.has(option.value)),
    [query.data, exclude]
  );

  return { options, isLoading: query.isLoading };
};
